/** Leadership profiles from https://hospital.iith.ac.in/ */

export const IITH_LEADERSHIP = [
  {
    name: 'Prof. B S Murty',
    title: 'Director, IITH',
    role: 'Director',
    photo: '/assets/iith-personnel/bsm.jpg',
    sourcePhoto: 'https://hospital.iith.ac.in/assets/images/bsm.jpg',
    profileUrl: 'https://hospital.iith.ac.in/',
    bio: 'Director of IIT Hyderabad — institutional leadership for campus healthcare and hospital governance.',
  },
  {
    name: 'Prof. Prem Pal',
    title: 'Dean Administration, IITH',
    role: 'Dean Admin',
    photo: '/assets/iith-personnel/prem.jpg',
    sourcePhoto: 'https://hospital.iith.ac.in/assets/images/prem.jpg',
    profileUrl: 'https://hospital.iith.ac.in/',
    bio: 'Dean (Administration) — administrative policy and support for the institute hospital.',
  },
  {
    name: 'Prof. Viswanath R R S R Chinthapenta',
    title: 'Faculty In-Charge, Hospital',
    role: 'FIC',
    photo: '/assets/iith-personnel/fic.jpg',
    sourcePhoto: 'https://hospital.iith.ac.in/assets/images/fic.jpg',
    profileUrl: 'https://hospital.iith.ac.in/',
    email: 'fic.hospital@iith.ac.in',
    bio: 'Faculty In-Charge of IITH Hospital — primary care, emergency readiness, and empanelled referrals.',
  },
];
